/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Rename_TitleInputs */



/**
* | output |
* | --- |
* | "Rename Record" |
*
* @param {Explorer_Info_Rename_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_rename_title = /** @type {((inputs?: Explorer_Info_Rename_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Rename_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Renommer l'enregistrement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Datensatz umbenennen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rinomina record")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Переименовать запись")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cambiar nombre de registro")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("重命名记录")
	if (locale === "ja") return /** @type {LocalizedString} */ ("レコード名の変更")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रिकॉर्ड का नाम बदलें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Renomear registro")
	return /** @type {LocalizedString} */ ("Rename Record")
});